var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGym = function SvgGym(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gym_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M23.382.618a2.11 2.11 0 0 0-2.983 0L.618 20.399a2.11 2.11 0 0 0 0 2.983L12.469 12.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B2B2",
    d: "M.618 23.382a2.11 2.11 0 0 0 2.983 0L23.382 3.601a2.11 2.11 0 0 0 0-2.983z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.4 15.461A1.992 1.992 0 1 0 .584 18.28l2.57 2.569 2.003-.551.814-2.267-.235-2.264-2.173-.143z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.555 11.981A1.992 1.992 0 1 0 2.738 14.8L5.97 18.03l1.858-.874.96-1.943zM14.799 2.738a1.992 1.992 0 0 0-2.818 2.817l3.232 3.232 2.084-1.1.733-1.717-.264-1.939-2.297-.623z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.279.583a1.992 1.992 0 1 0-2.817 2.818L18.03 5.97l2.313-.86.504-1.958z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.6 8.539a1.992 1.992 0 1 0 2.816-2.818l-2.568-2.569L18.03 5.97l.586 2.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.445 12.019A1.992 1.992 0 0 0 21.262 9.2L18.03 5.97l-2.817 2.817zM9.201 21.262a1.992 1.992 0 1 0 2.818-2.817l-3.232-3.232L5.97 18.03l.295 2.766 2.346-.124z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M5.721 23.416A1.992 1.992 0 0 0 8.54 20.6l-2.57-2.569-2.817 2.818z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gym_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGym;